import React               from 'react';
import Grid                from '@mui/material/Grid';
import TextField           from '@mui/material/TextField';
import Select              from '@mui/material/Select';
import MenuItem            from '@mui/material/MenuItem';

export default function MetaDataTop (props) {
	const { url, urlRegex, status, title, desc, shortDesc, onChange } = props;

	return (
		<>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={7} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<TextField
					required
					autoComplete="off"
					id="url-required"
					label="URL"
					value={url}
					name={'url'}
					style={{width: '100%'}}
					onChange={(e) => onChange (e)}
					helperText={`${ urlRegex === true ? "Correct-": "Incorrect-" } Made of alphabets, numbers and hyphen`}
				/>
			</Grid>
			<Grid item xs={12} md={3} style={{backgroundColor: '', margin: '20px 0 20px 10px'}}>
				<Select
					id="status-blog-select"
					value={status}
					name="status"
					label="Status"
					onChange={onChange}
					style={{width: '60%'}}
				>
					<MenuItem value={'published'}>Publish</MenuItem>
					<MenuItem value={'draft'}>Draft</MenuItem>
					<MenuItem value={'archived'}>Archive</MenuItem>
				</Select>
			</Grid>
		</Grid>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<TextField
					required
					id="title-required"
					label="Title"
					name="title"
					value={title}
					onChange={onChange}
					style={{width: '100%'}}
				/>
			</Grid>
		</Grid>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<TextField
					required
					id="desc-required"
					label="Description"
					name="desc"
					value={desc}
					onChange={onChange}
					style={{width: '100%'}}
				/>
			</Grid>
		</Grid>
		<Grid container spacing={1}>
			<Grid item xs={false} md={1} style={{backgroundColor: ''}}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 10px 20px 20px'}}>
				<TextField
					required
					id="short-desc-required"
					label="Short Description"
					name="shortDesc"
					value={shortDesc}
					onChange={onChange}
					helperText={`Max 300 Chars. ${shortDesc.trim ().length} chars`}
					style={{width: '100%'}}
				/>
			</Grid>
		</Grid>
		</>
	);
}
